import _asyncToGenerator from "@babel/runtime-corejs3/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime-corejs3/regenerator";
import { useCallback } from 'react';
import { callbacks, hooks } from '../../../config/api';
import { isHttpSuccess } from '../../utils/isHttpSuccess';
export var useCreateSocialInsurance = function useCreateSocialInsurance(contactId) {
  var invalidateQueries = hooks.useInvalidateQueries();
  var _hooks$useCreateRecor = hooks.useCreateRecord('insurance', {
      mutationConfig: {
        onError: function onError() {
          return callbacks.toast.error('Error adding insurance for client; please try again.');
        },
        onSettled: function onSettled() {
          invalidateQueries('insurance');
          invalidateQueries('plan');
          callbacks.fetchRecentUpdates();
        }
      }
    }),
    createInsurance = _hooks$useCreateRecor.createRecord;
  return useCallback(/*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
      var planId, startDateInEpochSeconds, endDateInEpochSeconds, primaryInsuranceId, createResponse;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            planId = _ref.planId, startDateInEpochSeconds = _ref.startDateInEpochSeconds, endDateInEpochSeconds = _ref.endDateInEpochSeconds, primaryInsuranceId = _ref.primaryInsuranceId;
            _context.next = 3;
            return createInsurance({
              person: contactId,
              plan: planId,
              primary_health_insurance: primaryInsuranceId,
              enrolled_at: startDateInEpochSeconds ? new Date(startDateInEpochSeconds * 1000).toISOString() : undefined,
              expired_at: endDateInEpochSeconds ? new Date(endDateInEpochSeconds * 1000).toISOString() : undefined
            });
          case 3:
            createResponse = _context.sent;
            if (isHttpSuccess(createResponse.status)) {
              callbacks.toast.success('Social Care Coverage Added');
            }
            return _context.abrupt("return", createResponse);
          case 6:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }(), [contactId, createInsurance]);
};
//# sourceMappingURL=useCreateSocialInsurance.js.map